<div class="results-container" style="
width:100%;" style="
width:100%;" *ngIf="data$ | async as data">
  <div *ngIf="isDataLoaded; then tabset else errorPage"></div>
  <ng-template #tabset>
    <div class="tabset-container">
    <div style="width: 100%;">
      <div class="open-filters" *ngIf="viewSwitch && !openFilter && isNvmf">
        <c11n-button [buttonType]="'button'" [size]="'small'" [iconName]="'filter'" [labelText]="'Open filters'" (clickEvent)="openFilters()" variant="secondary"></c11n-button>
        <div class="vg-paragraph-two filters" [cdkAriaLive]="'polite'" aria-live="polite" aria-atomic="true">
          <span class="num-totresults-detailview" *ngIf="!areAllFiltersEmpty"><strong>{{ numOfResults }}</strong> of {{NVGnumTotalResults}} results</span>
          <span class="num-results-detailview" *ngIf="areAllFiltersEmpty">{{numOfResults}} results</span>
        </div>
      </div>
      <div class="open-filters" *ngIf="viewSwitch && !openFilter && !isNvmf" >
        <c11n-button [buttonType]="'button'" [size]="'small'" [iconName]="'filter'"  [labelText]="'Open filters'" (clickEvent)="openFilters()" variant="secondary"></c11n-button>
        <div class="vg-paragraph-two filters" [cdkAriaLive]="'polite'" aria-live="polite" aria-atomic="true">
          <span class="num-totresults-detailview" *ngIf="!areAllFiltersEmpty"><strong>{{ numOfResults }}</strong> of {{numTotalResults}} results</span>
          <span class="num-results-detailview" *ngIf="areAllFiltersEmpty">{{numOfResults}} results</span>
        </div>
      </div>
    </div>
    </div>
    <VFA-detail-view *ngIf="viewSwitch" [closeFilters]='closeFilters' [openFilter]='openFilter' [fullData]="data.fund?.entity | sortBy: sortColumn: sortDirection: switchModel" [comparedFunds]='comparedFunds' [pageNumber]='page' [disableSwitch]='disableSwitch' (changeResultsData)="changeSortData($event)" [sortDirection]='sortDirection' [sortColumn]='sortColumn' [filterBy]='filterBy'></VFA-detail-view>
    <div class="paginationView">
    <list-pagination *ngIf="data.fund?.entity?.length > 0" [listSize]="data.fund?.entity?.length" (pageNumber)="setPage($event)"></list-pagination>
  </div>
  </ng-template>

  <ng-template #errorPage>
    <div class="results-container">
      <p class="error-page">An error occured on page load</p>
    </div>

  </ng-template>
</div>


